import styled from 'styled-components';
import { IPOStyleMixins } from '../../../styles';
export const OperationDomWrap = styled.div`
	margin-top: 40px;
	${IPOStyleMixins.flex('flex', 'end', 'center')}
	gap:20px;
	.news-title {
		width: 128px;
		height: 30px;
		background: #ffffff;
		border: 1px solid #ebecf0;
		text-align: center;
		line-height: 30px;
		color: #344563;
		font-size: 14px;
	}
	.news-content {
	}
`;
export const NewsDropdownWrap = styled.div`
	width: 100%;
	background: #ffffff;
	box-shadow: 0px 3px 8px 0px rgba(23, 43, 77, 0.18);
	border-radius: 4px;
	border: 1px solid #dfe1e6;
	margin-top: -6px;
	text-align: left;
	color: #344563;
	font-size: 14px;
	.news-content {
		height: 28px;
		line-height: 28px;
		padding-left: 12px;
		cursor: pointer;
		:hover {
			background: #f4f5f7;
		}
	}
`;
